import React, { useContext, useEffect, useState } from "react";

import { useGetSpecificFormQuery } from "../../../../Redux/service/Forms/Form";
import { popupcontext } from "../../../../context/Popupscontext";
import Popup from "../../../Helpers/Popup/Popup";
import Loader from "../../../Helpers/Loader/Loader";
import { Modal } from "react-bootstrap";
import { Select } from "antd";
import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../../Helpers/CloseBtn/Close";
import AntCalendar from "../../../FormBuilderInputs/Calendar";
import AntCheckBox from "../../../FormBuilderInputs/CheckBox";
import AntDatePicker from "../../../FormBuilderInputs/DatePicker";
import DropdownInput from "../../../FormBuilderInputs/DropdownInput";
import NormalInput from "../../../FormBuilderInputs/NormalInput";
import RadioGroup from "../../../FormBuilderInputs/RadioGroup";
import AntTextArea from "../../../FormBuilderInputs/TextArea";
import Toggle from "../../../FormBuilderInputs/Toggle";
import AntUpload from "../../../FormBuilderInputs/Upload";
import AntButton from "../../../FormBuilderInputs/Button";
import AntHeader from "../../../FormBuilderInputs/Header";
import Image from "../../../FormBuilderInputs/Image";
import Label from "../../../FormBuilderInputs/Label";
import Link from "../../../FormBuilderInputs/Link";
import ProgressCircle from "../../../FormBuilderInputs/ProgressCircle";
import ProgressLine from "../../../FormBuilderInputs/ProgressLine";
import UISignature from "../../../FormBuilderInputs/Signature";
import SnippetCamera from "../../../FormBuilderInputs/Camera";
import ContainerPreview from "../../../FormBuilderInputs/ContainerPreview";
import RepeatingGroupPreview from "../../../FormBuilderInputs/RepeatingGroupPreview";
import trans from "../../../../utils";
import {
	getDerivedPropertiesForSource,
	resolveRuntimeValues,
	evaluateVisibilityRules,
	flattenFormFields,
} from "../../../FormBuilder/runtimeValues";

export default function FormsPopup({ formId, type, onClose, zIndex = 1060 }) {
	let { handleClose, edited } = useContext(popupcontext);
	let { data, isLoading, refetch } = useGetSpecificFormQuery(formId, {
		skip: !formId,
	});

	// Shared preview form data so dependent dropdowns can read each other's values
	const [submitData, setSubmitData] = useState([]);

	useEffect(() => {
		if (edited) {
			refetch();
		}
	}, [edited, refetch]);

	// Reset submit data when the viewed form changes
	useEffect(() => {
		setSubmitData([]);
	}, [formId]);

	const closeform = () => {
		if (type === "form") {
			handleClose("display");
		}
		if (type === "task") {
			onClose();
		}
	};
	const isFieldVisible = (field, values) => {
		return evaluateVisibilityRules(field?.visibilityRules, values);
	};
	const updateTopLevelValue = (fieldKey, value) => {
		setSubmitData((prev) => {
			const field = data?.data?.formSchema?.fields?.find(
				(item) => item.key === fieldKey
			) || {};
			return [
				...(prev || []).filter((entry) => entry.key !== fieldKey),
				{ key: fieldKey, name: field.name, title: field.title, value },
			];
		});
	};

	const getInputType = (item, runtimeScope = null) => {
		const rawValuesMap = Object.fromEntries(
			(submitData || []).map((entry) => [entry.key, entry.value])
		);
		const scopeFields =
			runtimeScope?.fields || flattenFormFields(data?.data?.formSchema?.fields) || [];
		const valuesMap =
			runtimeScope?.values || resolveRuntimeValues(scopeFields, rawValuesMap);
		const onValueChange = runtimeScope?.onValueChange;
		if (!isFieldVisible(item, valuesMap)) return null;

		switch (item?.name) {
			case "Checkbox":
				return <AntCheckBox item={item} />;
			case "DatePicker":
			case "DateTime":
				return <AntDatePicker item={item} preview={true} />;
			case "Dropdown":
			case "MultiSelect":
				return (
					<DropdownInput
						item={item}
						preview={true}
							submitData={submitData}
							setSubmitData={setSubmitData}
							value={valuesMap[item.key]}
							onValueChange={onValueChange}
							scopeValues={valuesMap}
							includeProperties={getDerivedPropertiesForSource(
								scopeFields,
								item.key
							)}
						/>
				);

			case "Input":
				return (
					<NormalInput
						item={item}
						preview={true}
						submitData={submitData}
						setSubmitData={setSubmitData}
						value={valuesMap[item.key]}
						onValueChange={onValueChange}
					/>
				);
			case "Container":
				return (
					<ContainerPreview
						getInputType={getInputType}
						ukey={item?.id}
						item={item?.container}
						css={item?.css}
					/>
				);
			case "RepeatingGroup":
				return (
					<RepeatingGroupPreview
						getInputType={getInputType}
						item={item}
						value={valuesMap[item.key]}
						onValueChange={updateTopLevelValue}
					/>
				);
			case "DerivedValue":
			case "ComputedValue":
				if (item.derivedConfig?.defaultValueOptions) {
					return (
						<Select
							style={{ width: "100%" }}
							value={valuesMap[item.key] ?? item.derivedConfig.defaultValue ?? null}
							options={(item.derivedConfig.defaultValueOptions.data || []).map((opt) => ({
								label: String(opt),
								value: opt,
							}))}
							onChange={(value) => updateTopLevelValue(item.key, value)}
							placeholder={trans("Select a value")}
							allowClear
						/>
					);
				}
				return (
					<NormalInput
						item={{
							...item,
							readOnly: true,
							placeholder: trans("Auto-calculated"),
						}}
						preview={true}
						value={valuesMap[item.key] ?? item.derivedConfig?.defaultValue}
						onValueChange={() => {}}
						readOnly={true}
					/>
				);
			case "Radio_group":
				return <RadioGroup item={item} preview={true} />;

			case "Text_area":
				return <AntTextArea item={item} preview={true} />;

			case "Toggle":
				return <Toggle item={item} />;
			case "Uploader":
				return <AntUpload item={item} />;
			case "Button":
				return <AntButton item={item} />;

			case "Header":
				return <AntHeader item={item} />;
			case "Image":
				return <Image item={item} />;
			case "Label":
				return <Label item={item} />;
			case "Link":
				return <Link item={item} />;

			case "Progress_circle":
				return <ProgressCircle item={item} />;
			case "Progress_line":
				return <ProgressLine item={item} />;
			case "Signature":
				return <UISignature item={item} preview={true} />;
			case "Camera":
				return <SnippetCamera item={item} preview={true} />;
			default:
				return;
		}
	};
	console.log("this form is open");
	return (
		<Popup show={!!formId} zIndex={zIndex}>
			{isLoading && (
				<div className="loader-container">
					<Loader />
				</div>
			)}
			<Modal.Header className="modal-header flex-between ">
				<Modal.Title id="contained-modal-title-vcenter">
					<PopupTitle
						headtitle={`${data?.data?.name}`}
						subtitle={`${data?.data?.code}`}
					/>
				</Modal.Title>
				<Close
					// eslint-disable-next-line react/style-prop-object
					style="close-32 close"
					close={closeform}
					img="Close"
				/>
			</Modal.Header>
			<Modal.Body
				className="modal-body-scrollable"
				style={{ height: "calc(100vh - 140px)", overflowX: "hidden" }}
			>
				{data?.data?.formSchema?.fields.map((i) => (
					<div className={`mb-2`} style={i.css}>
						{getInputType(i)}
					</div>
				))}
			</Modal.Body>
		</Popup>
	);
}
